/**
 * images - /public/img/product-types-fill
 */

export const BusinessGoals = [
    {
        // Selling Plans
        name_t: "BusinessGoalSellingPlans",
        desc_t: "BusinessGoalSellingPlansText",
        value: "selling-plans",
    },

    {
        // Traffic Acquisition
        name_t: "BusinessGoalTrafficAcquisition",
        desc_t: "BusinessGoalTrafficAcquisitionText",
        value: "traffic-acquisition",
    },
];

export const BusinessGoalsECommerce = [
    {
        // Selling Plans
        name_t: "BusinessGoalSellingOnline",
        desc_t: "BusinessGoalSellingOnlineText",
        value: "selling-online",
    },

    {
        // Traffic Acquisition
        name_t: "BusinessGoalLeadGeneration",
        desc_t: "BusinessGoalLeadGenerationText",
        value: "lead-generation",
    },
];
